module.exports = __webpack_public_path__ + "img/icon-auditing.2c7b6065.png";